import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import './index.scss';
import { getTreppCLOEnabled } from '$/store/release-feature-flags/selectors';
import CloList from '$/pages/admin/clo/cloList';
import CloDealListRoot from '$/pages/admin/clo/cloDealListRoot';

interface ICloListRootProps {
  isTreppCLOEnabled: boolean;
}

const CloListRoot: React.FC<ICloListRootProps> = props => {
  const { isTreppCLOEnabled } = props;

  if (isTreppCLOEnabled) {
    return <CloDealListRoot />;
  }

  return <CloList />;
};

const mapStateToProps = (state: AppState) => {
  const { isTreppCLOEnabled } = getTreppCLOEnabled(state);

  return {
    isTreppCLOEnabled,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CloListRoot);
